import { WalletProviderEnum } from '@dynamic-labs/sdk-api-core';

import { InvalidWalletProviderKeyError } from '../../../../errors/InvalidWalletProviderKeyError';

type SplitWalletProviderKeyResult = {
  normalizedWalletNameWithChain: string;
  suffix: string | undefined;
  walletProviderType: WalletProviderEnum;
};

export const splitWalletProviderKey = (
  walletProviderKey: string
): SplitWalletProviderKeyResult => {
  const [normalizedWalletNameWithChain, walletProviderType, suffix, ...rest] =
    walletProviderKey.split(':');

  if (
    !normalizedWalletNameWithChain ||
    !Object.values(WalletProviderEnum).includes(
      walletProviderType as WalletProviderEnum
    ) ||
    rest.length > 0
  ) {
    throw new InvalidWalletProviderKeyError(walletProviderKey);
  }

  return {
    normalizedWalletNameWithChain,
    suffix,
    walletProviderType: walletProviderType as WalletProviderEnum,
  };
};
